function _typeof(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

var _dec, _dec2, _class, _class2;

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); if (superClass) _setPrototypeOf(subClass, superClass); }

function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }

function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } return _assertThisInitialized(self); }

function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }

function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }

function _applyDecoratedDescriptor(target, property, decorators, descriptor, context) { var desc = {}; Object.keys(descriptor).forEach(function (key) { desc[key] = descriptor[key]; }); desc.enumerable = !!desc.enumerable; desc.configurable = !!desc.configurable; if ('value' in desc || desc.initializer) { desc.writable = true; } desc = decorators.slice().reverse().reduce(function (desc, decorator) { return decorator(target, property, desc) || desc; }, desc); if (context && desc.initializer !== void 0) { desc.value = desc.initializer ? desc.initializer.call(context) : void 0; desc.initializer = undefined; } if (desc.initializer === void 0) { Object.defineProperty(target, property, desc); desc = null; } return desc; }

import { Brick } from "zengular";
import twig from "./content-nav.twig";
import "./content-nav.scss";
import service from "../modules/services/services";
import WriteBlogpost from "../modals/write-blogpost.brick";
import AppEvent from "zengular/src/app-event";
import CreateTopic from "../modals/create-topic.brick";
import registry from "zengular/src/brick-registry";
var ContentNavBrick = (_dec = Brick.register('content-nav', twig), _dec2 = Brick.listen('searchbar-visible'), _dec(_class = (_class2 = /*#__PURE__*/function (_Brick) {
  _inherits(ContentNavBrick, _Brick);

  var _super = _createSuper(ContentNavBrick);

  function ContentNavBrick() {
    _classCallCheck(this, ContentNavBrick);

    return _super.apply(this, arguments);
  }

  _createClass(ContentNavBrick, [{
    key: "onInitialize",
    value: function onInitialize() {
      this.user = service.User.current;
      this.root.classList.add(this.dataset.type);
    }
  }, {
    key: "createViewModel",
    value: function createViewModel() {
      return {
        user: this.user,
        edit: typeof this.dataset.edit !== "undefined" ? this.dataset.edit : false,
        create: this.dataset.create === 'yes',
        search: this.dataset.search === 'yes',
        type: this.dataset.type
      };
    }
  }, {
    key: "onRender",
    value: function onRender() {
      var _this = this;

      this.$$('write-blogpost').on.mouse.click(function () {
        return WriteBlogpost.modalify(true);
      });
      this.$$('create-topic').on.mouse.click(function () {
        return CreateTopic.modalify({
          type: _this.dataset.type
        });
      });
      this.$$('edit-blogpost').on.mouse.click(function () {
        return WriteBlogpost.modalify(parseInt(_this.dataset.edit));
      });
      this.$$('search').on.mouse.click(function () {
        AppEvent.broadcast('show-searchbar');
      });
      this.$$('cancel-search').on.mouse.click(function () {
        AppEvent.broadcast('cancel-search');
      });
    }
  }, {
    key: "hideMagnifier",
    value: function hideMagnifier() {
      registry;
      this.$$('search').node.style.display = 'none';
      this.$$('cancel-search').node.style.display = 'block';
    }
  }]);

  return ContentNavBrick;
}(Brick), (_applyDecoratedDescriptor(_class2.prototype, "hideMagnifier", [_dec2], Object.getOwnPropertyDescriptor(_class2.prototype, "hideMagnifier"), _class2.prototype)), _class2)) || _class);
export { ContentNavBrick as default };